import { render, staticRenderFns } from "./CustomizableTools.vue?vue&type=template&id=65db80a4&scoped=true"
import script from "./CustomizableTools.vue?vue&type=script&lang=js"
export * from "./CustomizableTools.vue?vue&type=script&lang=js"
import style0 from "./CustomizableTools.vue?vue&type=style&index=0&id=65db80a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db80a4",
  null
  
)

export default component.exports